import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import TrackingActions from "../../actions/TrackingActions";

import { translate as t } from '../../lib/I18n';
import Search from '../../records/Search';

import Checkbox from '../form/Checkbox';
import FeatureFlag from '../general/FeatureFlag';

class DepartNowCheckbox extends React.PureComponent {

    static propTypes = {
        search: PropTypes.instanceOf(Search),
        onChange: PropTypes.func
    };

    static defaultProps = {
        search: new Search(),
        onChange: _.noop
    };

    toggleNow = () => {
        TrackingActions.widgetSearchClick({ name: `depart-now:${!this.props.search.departNow}` });
        const { search, onChange } = this.props;
        onChange(search.set('departNow', !search.departNow));
    };

    render () {
        return (
            <FeatureFlag name="enableDepartNow">
                <Checkbox id="departNow"
                    label={ t('booking.search.departNowLabel') }
                    groupClassName="form-group open-return"
                    checked={ Boolean(this.props.search.departNow) }
                    onChange={ this.toggleNow }
                />
            </FeatureFlag>
        );
    }
}

export default DepartNowCheckbox;



// WEBPACK FOOTER //
// ./src/components/search/DepartNowCheckbox.js